/* eslint-disable no-unreachable */
/* eslint-disable no-console */
/* eslint-disable no-debugger */
import axios from "./index";

export function signUp(param) {
    return axios({
        method: 'post',
        url: '/user/public/nocRegister',
        data: param,
    });
}

export function updateSignUpInfo(param) {
    return axios({
        method: 'post',
        url: '/enroll/info/update',
        data: param,
    });
}

export function getGroups(id) {
    const url = `/module/reg/${id}`
    return axios({
        method: 'get',
        url
    });
}
const envPath = {
    development: '/test',
    production: '/prod',
    preview: '/preview'
}
export function getNocInfo() {
    return axios({
        method: 'get',
        baseURL: `https://static.xiaohoucode.com/noc-config${envPath[process.env.VUE_APP_ENV]}`,
        url: 'config.json',
        params: {
            t: Date.now()
        }
    });
}
let TOKEN = ''
let TOKEN_TIME = 0
let expire = 0
const checkToken = () => {
    if (TOKEN && (Date.now() - TOKEN_TIME) < expire * 1000) {
        return true
    }
    return false
}
export function getToken() {
    if (checkToken()) {
        return Promise.resolve(TOKEN)
    }
    // return Promise.resolve({
    //     "status": "success",
    //     "status_code": 200,
    //     "message": "操作成功",
    //     "data": {
    //         "access_token": "eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJlM2ViNDE5NDI3OGRmMGY5MTI1ODYzMjY4MmQwYWU5MiIsImlkIjo3NjMzLCJ0eXBlIjoiQ09PUEVSX09QRU4iLCJleHBpcmVBdCI6MTcwNjU0MDE5OSwiaWF0IjoxNzA2NTI5Mzk5OTkxfQ.dviJW856ewUN2BpxphXV0ZnzjaVnyRhBdeupQFSmUXCVTHniXG2ycZ5Cgz6ArJ1xxtPgDMgqOrVwYl4h-Ns8og",
    //         "expire": 7200
    //     }
    // }).then(res => {
    //     TOKEN = res.data.access_token
    //     TOKEN_TIME = Date.now()
    //     expire = res.data.expire
    //     return TOKEN
    // });
    return axios({
        method: 'get',
        url: '/user/public/yq/token',
        params: {
            t: Date.now()
        }
    }).then(res => {
        TOKEN = res.data.accessToken
        TOKEN_TIME = Date.now()
        expire = res.data.expireCache
        return TOKEN
    });
}
export function getExamList() {
    return getToken().then((token) => {
        return axios({
            method: 'post',
            baseURL: process.env.VUE_APP_YUANQUAN,
            url: '/v2/school/exam/get_exam_list',
            data: {
                access_token: token,
                t: Date.now()
            }
        });
    });
}
export function getLoginUrl({ exam_id, login_param1, login_param2 }) {
    return getToken().then((token) => axios({
        method: 'post',
        baseURL: process.env.VUE_APP_YUANQUAN,
        url: '/v2/school/custom-param/login',
        data: {
            exam_id,
            login_param1,
            login_param2,
            access_token: token,
            secret: process.env.VUE_APP_YUANQUAN_SECRET
        }
    }));
}
export function getCurrentTimestamp() {
    return axios({
        method: 'get',
        url: 'noc/signUpData/currentTimeMillis',
        params: {
            t: Date.now()
        }
    });
}